import { useState } from "react";
import QrScannerComponent from "../../../shared/QrScannerComponent";

const ScanQrMask = ({data, setData, setStep}) => {

    const [isScanned, setIsScaned] = useState(false);
    const [qrCode, setQrCode] = useState("");
    const [qrError, setQrError] = useState("");

    return (
        <>
            {!isScanned &&
                <QrScannerComponent setQr={setQrCode} setErr={setQrError} />
            }
        </>
    )
}
export default ScanQrMask;